<template>
  <div class="order-submission">
    <div class="allAddress" :style="store_self_mention ? '' : 'padding-top: 0.2rem'">
      <div class="deposit-title">押金信息确认</div>
      <div class="deposit-info">
        <div class="info-item acea-row">
          <span class="iconfont icon-duihao info-icon"></span>
          <span class="info-text">押金金额务必事先与业务员沟通确认好；</span>
        </div>
        <div class="info-item acea-row">
          <span class="iconfont icon-duihao info-icon"></span>
          <span class="info-text">提交支付后，可在"我的订单"查看押金订单；</span>
        </div>
        <div class="info-item acea-row">
          <span class="iconfont icon-duihao info-icon"></span>
          <span class="info-text">押金可用于分期单后期还款，分期订单完结后押金余额可全额退还。</span>
        </div>
      </div>
      <div class="line">
        <img src="@assets/images/line.jpg" />
      </div>
    </div>

    <OrderGoods :evaluate="0" :cartInfo="orderGroupInfo.cartInfo"></OrderGoods>

    <div class="wrapper">
        <div class="item acea-row row-between-wrapper">
        <div>备注信息</div>
        <input type="text" style="text-align:right" placeholder="留言前请先与商家沟通" v-model="mark"/>
      </div>
    </div>

    <div class="wrapper">
      <div class="item">
        <div>支付类型</div>
        <div class="list">
          <div class="payItem acea-row row-middle" :class="active === index ? 'on' : ''"
            v-for="(item, index) in cartArr" :key="index" @click="payItem(index)">
            <div class='name acea-row row-center-wrapper'>
              <div class="iconfont" :class="active === index ? 'bounceIn ' + item.icon : item.icon"></div>
              {{ item.name }}
            </div>
            <div class='tip'>{{ item.title }}</div>
          </div>
        </div>
      </div>
    </div>

    <div style="height:1.8rem"></div>
    <div class="footer acea-row row-between-wrapper">
      <div>
        合计押金:
        <span class="font-color-red">￥{{ orderPrice.pay_price }}</span>
      </div>
      <div class="settlement" @click="createOrder">提交押金</div>
    </div>
    <CouponListWindow v-on:couponchange="changecoupon($event)" v-model="showCoupon" :price="orderPrice.total_price"
      :checked="usableCoupon.id" :cartid="cartid" @checked="changeCoupon"></CouponListWindow>
    <AddressWindow @checked="changeAddress" @redirect="addressRedirect" v-model="showAddress" :checked="addressInfo.id"
      ref="mychild"></AddressWindow>
  </div>
</template>
<style scoped>
.order-submission .wrapper .shipping select {
  color: #999;
  padding-right: 0.15rem;
}

.order-submission .wrapper .shipping .iconfont {
  font-size: 0.3rem;
  color: #515151;
}

.order-submission .allAddress {
  width: 100%;
  background-image: linear-gradient(to bottom, #e93323 0%, #f5f5f5 100%);
  background-image: -webkit-linear-gradient(to bottom,
      #e93323 0%,
      #f5f5f5 100%);
  background-image: -moz-linear-gradient(to bottom, #e93323 0%, #f5f5f5 100%);
  padding-top: 1rem;
}

.order-submission .allAddress .nav {
  width: 7.1rem;
  margin: 0 auto;
}

.order-submission .allAddress .nav .item {
  width: 3.25rem;
}

.order-submission .allAddress .nav .item.on {
  position: relative;
  width: 2.5rem;
}

.order-submission .allAddress .nav .item.on:before {
  position: absolute;
  bottom: 0;
  content: "快递配送";
  font-size: 0.28rem;
  display: block;
  height: 0;
  width: 3.25rem;
  border-width: 0 0.2rem 0.8rem 0;
  border-style: none solid solid;
  border-color: transparent transparent #fff;
  z-index: 9;
  border-radius: 0.07rem 0.3rem 0 0;
  text-align: center;
  line-height: 0.8rem;
}

.order-submission .allAddress .nav .item:nth-of-type(2).on:before {
  content: "到店自提";
  border-width: 0 0 0.8rem 0.2rem;
  border-radius: 0.3rem 0.07rem 0 0;
}

.order-submission .allAddress .nav .item.on2 {
  position: relative;
}

.order-submission .allAddress .nav .item.on2:before {
  position: absolute;
  bottom: 0;
  content: "到店自提";
  font-size: 0.28rem;
  display: block;
  height: 0;
  width: 4.6rem;
  border-width: 0 0 0.6rem 0.6rem;
  border-style: none solid solid;
  border-color: transparent transparent #f7c1bd;
  border-radius: 0.4rem 0.06rem 0 0;
  text-align: center;
  line-height: 0.6rem;
}

.order-submission .allAddress .nav .item:nth-of-type(1).on2:before {
  content: "快递配送";
  border-width: 0 0.6rem 0.6rem 0;
  border-radius: 0.06rem 0.4rem 0 0;
}

.order-submission .allAddress .address {
  width: 7.1rem;
  height: 1.5rem;
  margin: 0 auto;
}

.order-submission .allAddress .deposit-title {
  width: 7.1rem;
  margin: 0 auto;
  font-size: 0.34rem;
  font-weight: 600;
  color: #6a0f0f;
  text-align: center;
  padding: 0.2rem 0 0.15rem 0;
}

.order-submission .allAddress .deposit-info {
  width: 7.1rem;
  margin: 0 auto;
  padding: 0 0 0.2rem 0;
}

.order-submission .allAddress .deposit-info .info-item {
  font-size: 0.28rem;
  color: #6a0f0f;
  line-height: 1.8;
  padding: 0.04rem 0;
  align-items: flex-start;
}

.order-submission .allAddress .deposit-info .info-item .info-icon {
  font-size: 0.28rem;
  color: #e93323;
  margin-right: 0.12rem;
  flex-shrink: 0;
  line-height: 1.8;
}

.order-submission .allAddress .deposit-info .info-item .info-text {
  flex: 1;
  min-width: 0;
  text-align: left;
  word-wrap: break-word;
}

.order-submission .allAddress .line {
  width: 7.1rem;
  margin: 0 auto;
  margin-top: 0.05rem;
}

.order-submission .wrapper .item .discount input::placeholder {
  color: #ccc;
}

.order-submission .installmentsInfo {
  border-left: 1px solid #eee;
  border-right: 1px solid #eee;
  border-bottom: 1px solid #eee;
  border-bottom-left-radius: 0.06rem;
  border-bottom-right-radius: 0.06rem; /* 修正了原文中重复的 border-bottom-left-radius */
  width: 100%;
  box-sizing: border-box;
  margin-top: -0.03rem;
  padding: 0.12rem 0 0.15rem 0;
}

.order-submission .wrapper .item .installmentsInfo .info {
  text-align: left;
  font-size: 0.26rem;
  color: #aaa;
  padding: 0.06rem 0 0 0.3rem;
}

 input::placeholder {
  color: #ccc; 
}
</style>

<script>
import OrderGoods from "@components/OrderGoods";
import CouponListWindow from "@components/CouponListWindow";
import AddressWindow from "@components/AddressWindow";
import { postOrderConfirm, postOrderComputed, createOrder } from "@api/order";
import { storeListApi } from "@api/store";
import { getUser } from "@api/user";
import { pay } from "@libs/wechat";
import { isWeixin } from "@utils";
import { mapGetters } from "vuex";
import cookie from "@utils/store/cookie";
const NAME = "DepositSubmission",
  _isWeixin = isWeixin();
const LONGITUDE = "user_longitude";
const LATITUDE = "user_latitude";
export default {
  name: NAME,
  components: {
    OrderGoods,
    CouponListWindow,
    AddressWindow
  },
  props: {},
  computed: {
    ...mapGetters(["storeItems"]),
    storeItem: function () {
      if (JSON.stringify(this.storeItems) == "{}") {
        return this.storeList;
      } else {
        return this.storeItems;
      }
    }
  },
  data: function () {
    return {
      cartid: "",
      offlinePayStatus: 2,
      from: _isWeixin ? "weixin" : "weixinh5",
      deduction: true,
      isWeixin: _isWeixin,
      pinkId: 0,
      active: 0,
      showCoupon: false,
      showAddress: false,
      addressInfo: {},
      couponId: 0,
      orderGroupInfo: {
        priceGroup: {}
      },
      usableCoupon: {},
      addressLoaded: false,
      useIntegral: false,
      orderPrice: {
        pay_price: "计算中"
      },
      mark: "",
      system_store: {},
      shipping_type: 0,
      contacts: "",
      contactsTel: "",
      store_self_mention: 0,
      userInfo: {},
      storeList: {},
      cartArr: [
        {
          name: "全款购买",
          icon: "icon-zhifubao",
          value: "quanKuan",
          title: "支付宝安全支付",
          payType: "alipay",
          installments: []
        }
      ],
      installmentsInfo: [],
      interestRate: '0',      //分期利率
      buyMethod:'quanKuan',   //购买方式
      selectedInstallment:{}, //选中分期
      payType:'weixin',       //支付方式
    };
  },
  watch: {
    useIntegral() {
      this.computedPrice();
    },
    $route(n) {
      if (n.name === NAME) {
        console.log(this.$route.query.pinkid);
        if (this.$route.query.pinkid !== undefined)
          this.pinkId = this.$route.query.pinkid;
        else {
          this.pinkId = 0;
        }
        this.getUserInfo();
        this.getCartInfo();
      }
    },
    shipping_type() {
      this.computedPrice();
    }
  },
  mounted: function () {
    let that = this;
    that.getUserInfo();
    that.getCartInfo();
    that.getList();
    if (this.$route.query.pinkid !== undefined)
      this.pinkId = this.$route.query.pinkid;
    if (that.$route.params.id !== undefined)
      that.cartid = that.$route.params.id;
  },
  methods: {
    // 获取门店列表数据
    getList: function () {
      let data = {
        latitude: cookie.get(LATITUDE) || "", //纬度
        longitude: cookie.get(LONGITUDE) || "", //经度
        page: 1,
        limit: 10
      };
      // storeListApi(data)
      //   .then(res => {
      //     this.storeList = res.data.list[0];
      //   })
      //   .catch(err => {
      //     this.$dialog.error(err.msg);
      //   });
    },

    // 跳转到门店列表
    showStoreList() {
      this.$store.commit("GET_TO", "orders");
      this.$router.push("/shop/storeList/orders");
    },

    getUserInfo() {
      getUser()
        .then(res => {
          this.userInfo = res.data;
        })
        .catch(() => { });
    },
    addressType: function (index) {
      if (index && !this.system_store.id)
        return this.$dialog.error("暂无门店信息，您无法选择到店自提！");
      this.shipping_type = index;
    },

    computedPrice() {
      let shipping_type = this.shipping_type;
      postOrderComputed(this.orderGroupInfo.orderKey, {
        addressId: this.addressInfo.id,
        useIntegral: this.useIntegral ? 1 : 0,
        couponId: this.usableCoupon.id || 0,
        shipping_type: parseInt(shipping_type) + 1,
        payType: this.payType
      })
        .then(res => {
          const data = res.data;
          if (data.status === "EXTEND_ORDER") {
            this.$router.replace({
              path: "/order/detail/" + data.result.orderId
            });
          } else {
            this.orderPrice = data.result;
          }
        })
        .catch(res => {
          this.$dialog.error(res.msg);
        });
    },

    getCartInfo() {
      const cartIds = this.$route.params.id;
      if (!cartIds) {
        this.$dialog.error("参数有误");
        return this.$router.go(-1);
      }
      postOrderConfirm(cartIds)
        .then(res => {
          this.offlinePayStatus = res.data.offline_pay_status;
          this.orderGroupInfo = res.data;
          this.deduction = res.data.deduction;
          this.usableCoupon = res.data.usableCoupon || {};
          this.addressInfo = res.data.addressInfo || {};
          this.system_store = res.data.system_store || {};
          this.store_self_mention = res.data.store_self_mention;
          this.active = 0;
          this.cartArr = res.data.pay_type_arr,
          this.interestRate = res.data.interest_rate,
          this.buyMethod = res.data.pay_type_arr[0].value,
          this.payType = res.data.pay_type_arr[0].payType
          this.computedPrice();
          if(res.data.tipMsg != '') {
            setTimeout(() => {
              this.$dialog.toast({
                mes: res.data.tipMsg,
                timeout: 4000
              });
            }, 600);
      }
        })
        .catch(err => {
            this.$dialog.error("加载订单数据失败");
            if(err.data.status === 400) {
              setTimeout(() => {
                this.$router.replace({ path: '/order/list/' })
              }, 1500);
            }
          }
        );
    },

    addressTap: function () {
      this.showAddress = true;
      if (!this.addressLoaded) {
        this.addressLoaded = true;
        this.$refs.mychild.getAddressList();
      }
    },

    addressRedirect() {
      this.addressLoaded = false;
      this.showAddress = false;
    },

    couponTap: function () {
      this.showCoupon = true;
    },

    changeCoupon: function (coupon) {
      if (!coupon) {
        this.usableCoupon = { coupon_title: "不使用优惠券", id: 0 };
      } else {
        this.usableCoupon = coupon;
      }
      this.computedPrice();
    },

    payItem: function (index) {
      let that = this;
      let active = index;
      if (that.cartArr[active].installments.length > 1) { //有多种分期方式【暂时不会有】

      }
      else {
        let oldActive = that.active;
        if (that.cartArr[oldActive].installments.length > 1) { //有多种分期方式，才需要重置提示语
          that.cartArr[oldActive].title = '点击选择期数';
          that.cartArr[oldActive].value = '';
        }
        if (that.cartArr[active].installments.length == 1) { //只有一种分期方式
          that.selectedInstallment = that.cartArr[active].installments[0];
        } else { //不是分期购买
          that.selectedInstallment = {};
        }
        that.active = active;
        that.buyMethod = that.cartArr[active].value;
        that.payType = that.cartArr[active].payType;
        that.cartArr = that.cartArr;
      }
    
      that.computedPrice();
    },

    changeAddress(addressInfo) {
      this.addressInfo = addressInfo;
      this.computedPrice();
    },

    createOrder() {
      let shipping_type = this.shipping_type;
      if (!this.buyMethod) {
        return this.$dialog.toast({ mes: "请选择支付方式" });
      }
      if (this.buyMethod != 'quanKuan' && this.userInfo.auth_status != 2) {
        this.$dialog.confirm({
          mes: "请用全款购买或先完成实名认证",
          title: "您还无法分期",
          opts: [
            {
              txt: "取消",
              color: false,
              callback: () => { }
            },
            {
              txt: "去认证",
              color: true,
              callback: () => {
                this.$router.push({ path: '/user/binding' });
              }
            }
          ]
        });
        return;
      }
 
      this.$dialog.loading.open("订单提交中");
      createOrder(this.orderGroupInfo.orderKey, {
        real_name: this.contacts,
        phone: this.contactsTel,
        addressId: 0,
        useIntegral: this.useIntegral ? 1 : 0,
        couponId: this.usableCoupon.id || 0,
        payType: this.payType,
        buyMethod: this.buyMethod,
        pinkId: this.pinkId,
        seckill_id: this.orderGroupInfo.seckill_id,
        combinationId: this.orderGroupInfo.combination_id,
        bargainId: this.orderGroupInfo.bargain_id,
        from: this.from,
        mark: this.mark || "",
        shipping_type: parseInt(shipping_type) + 1,
        store_id: this.storeItem ? this.storeItem.id : 0
      })
        .then(res => {
          this.$dialog.loading.close();
          const data = res.data;
          let url = "/order/status/" + data.result.orderId;
          switch (data.status) {
            case "ORDER_EXIST":
            case "EXTEND_ORDER":
            case "PAY_DEFICIENCY":
            case "PAY_ERROR":
              this.$dialog.toast({ mes: res.msg });
              this.$router.replace({
                path: url + "/0?msg=" + res.msg
              });
              break;
            case "SUCCESS":
              this.$dialog.success(res.msg);
              this.$router.replace({
                path: url + "/1?msg=" + res.msg
              });
              break;
            case "ALIPAY":
              // console.info('=====>' + data.result.jsConfig)
              // this.$router.replace({
              //   path: url + "/2"
              // });
              // setTimeout(() => {
              //   location.href = data.result.jsConfig;
              // }, 100);
              location.href = data.result.jsConfig;
              break;
            case "WECHAT_H5_PAY":
              this.$router.replace({
                path: url + "/2"
              });
              setTimeout(() => {
                location.href = data.result.jsConfig.mweb_url;
              }, 100);
              break;
            case "WECHAT_PAY":
              pay(data.result.jsConfig).finally(() => {
                this.$router.replace({
                  path: url + "/4"
                });
              });
          }
        })
        .catch(err => {
          this.$dialog.error(err.msg || "创建订单失败");
          this.$dialog.loading.close();
          this.$router.go(-1);
        });
    }
  }
};
</script>
